const priceHistory = [
    {
        dayOfWeek: '₹1199',
        totalSales: 30487,
        totalOrders: 1501,
    },
    {
        dayOfWeek: '₹2299',
        totalSales: 24361,
        totalOrders: 1540,
    },
    {
        dayOfWeek: '₹2499',
        totalSales: 21002,
        totalOrders: 2339,
    },
    {
        dayOfWeek: '₹2799',
        totalSales: 19820,
        totalOrders: 1987,
    },
    {
        dayOfWeek: '₹2999',
        totalSales: 22909,
        totalOrders: 1754,
    },
];

const salesGenerated = [];

const conversionRate = [
    {
        name: 'Visits',
        percentage: 52
    },
    {
        name: 'Purchases',
        percentage: 32
    },
    {
        name: 'Cart Abandonment',
        percentage: 16
    }
];

const returnRatio = [
    {
        name: '2023',
        percentage: 39,
    },
    {
        name: '2024',
        percentage: 16,
    }
];

const reviews = [
    {
        name: 'Excellent Reviews',
        percentage: 30,
    },
    {
        name: 'Fair Reviews',
        percentage: 58,
    },
    {
        name: 'Need Improvement',
        percentage: 12,
    }
];

const netRevenue = [
    {
        year: '2021',
        revenue: 30487,
    },
    {
        year: '2022',
        revenue: 24361,
    },
    {
        year: '2023',
        revenue: 21002,
    },
    {
        year: '2024',
        revenue: 19820,
    },
];

export {
    priceHistory,
    salesGenerated,
    conversionRate,
    returnRatio,
    reviews,
    netRevenue,
}
